import React, { useState, useEffect } from "react";
import { RadioGroup, Box, Stack, Alert, AlertTitle } from "@mui/material";
import SubmitButton from "../common/SubmitButton";
import Radio from "../Base/Radio/index";
import Note from "../common/Note";
import RadioLink from "../common/RadioLink";
import configData from "../../Config";
import Backdrop from "../common/Backdrop";
import LoadingDots from "../Lottie/LoadingDots";
import { useNavigate, useLocation } from "react-router-dom";
import { apis } from "../../services/apiService";
import styles from "../../Style/Modules/incomeProof.module.css";
import "../../Style/Theme/index.css";
import AlertPopup from "../common/AlertPopup";
import useSelector from "../../store/selector";
import { constant, decryptData } from "../../utils/utils";

const IncomeRadios = ({ skip }) => {
  const navigate = useNavigate();
  let location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [RValue, setRValue] = useState("");
  const [Adata, setAdata] = useState(false);
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  const { getRecoilVal, setRecoilVal } = useSelector();
  const recoilDataUser = getRecoilVal(constant?.atomsName.USER_DETAIL);
  const [checkPrograme, setCheckProgrameCheck] = useState();
  useEffect(() => {
    const programeNameCheckFunk = async () => {
      const getDecryptedProgrameName = await decryptData(
        recoilDataUser?.program
      );
      setCheckProgrameCheck(getDecryptedProgrameName);
    };
    programeNameCheckFunk();
  }, []);

  // console.log("check getDecryptedProgrameName----", getDecryptedProgrameName);
  const handleChange = (e) => {
    setDisabled(false);
    setRValue(e?.target?.value);
  };

  let skipHandler = () => {
    navigate("/loading", { state: { AppId: location.state.AppId } });
    // try {
    //   setLoading(true);
    //   const reqData = {
    //     aid: location.state.AppId,
    //     op: "AD",
    //   };

    //   let resp = await apis.postApi(
    //     configData.API_URL + "UploadDocument/AddIncomeProof",
    //     reqData
    //   );
    //   let result = await resp?.json();
    //   if (resp?.status === 200) {
    //     navigate("/loading", { state: { AppId: location.state.AppId } });
    //   }
    //   setLoading(false);
    // } catch (error) {
    //   const errorResult = JSON.parse(error?.message);
    //   setFinalErr(errorResult?.statusMessage);
    //   setLoading(false);
    // }
  };
  // let checkAnchorData = async () => {
  //   try {
  //     setLoading(true);
  //     const reqData = {
  //       aid: location.state.AppId,
  //     };

  //     let resp = await apis.postApi(
  //       configData.API_URL + "ApplicationFlow/CheckAnchorData",
  //       reqData
  //     );
  //     let result = await resp.json();
  //     if (resp?.status === 200) {
  //       setLoading(false);
  //       if (result?.data === "E") {
  //         setAdata(true);
  //         setRValue("AD");
  //       } else {
  //         setAdata(false);
  //       }
  //     }
  //   } catch (error) {
  //     //console.log(err);
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   checkAnchorData();
  // }, []);

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        aid: location.state.AppId,
        op: RValue,
      };
      let resp = await apis?.postApi(
        configData.API_URL + "UploadDocument/AddIncomeProof",
        reqData
      );
      let result = await resp?.json();
      if (resp?.status === 200) {
        if (RValue === "IT") {
          let data = { AppId: location.state.AppId };
          navigate("/upload-income-tax", { state: data });
        } else if (RValue === "BS") {
          let data = { AppId: location.state.AppId };
          navigate("/upload-bank-statement", { state: data });
        } else if (RValue === "GST") {
          let data = { AppId: location.state.AppId };
          navigate("/upload-gst-return", { state: data });
        } else if (RValue === "AD") {
          let data = { AppId: location.state.AppId };
          navigate("/loading", { state: data });
        }
      }
      setLoading(false);
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
      setLoading(false);
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <>
      <form
        autoComplete="off"
        id="incomeProof"
        // className={styles.incomeProofForm}
        onSubmit={handleSubmit}
      >
        <Box className={styles.incomeProofBox}>
          <RadioGroup name="proof" onChange={handleChange}>
            {/*<Radio*/}
            {/*  align="flex-start"*/}
            {/*  value="IT"*/}
            {/*  label="Income Tax Return downloaded xml/ITR form"*/}
            {/*              component={<RadioLink subtitle="Or go to ITR website" link="https://www.incometax.gov.in/" />}*/}
            {/*/>*/}
            <Radio
              align="flex-start"
              value="BS"
              // label="Bank statement of last six months downloaded from internet banking(PDF)"
              label="Bank Statement Upload / Account Aggregator"
              // label="Account Aggregator"
            />
            {/* <Radio
              align="flex-start"
              value="GST"
              label="GSTR-1/GSTR-3B returns of last six months"
              component={
                <RadioLink
                  subtitle="Or Go to GST portal"
                  link="https://www.gst.gov.in/"
                />
              }
            /> */}
          </RadioGroup>

          {/* <Note note="Please upload atleast 1 income proof to proceed." /> */}
          {/* <Note note="GSTR not available kindly proceed with bank statement / account aggregator" /> */}
        </Box>
        <SubmitButton
          hasNote="No"
          form="incomeProof"
          disabled={disabled}
          skip={checkPrograme === "Agrostar_RF" && skip}
          skipHandler={checkPrograme === "Agrostar_RF" && skipHandler}
        />
      </form>
      {loading && (
        <Backdrop ax="center">
          <LoadingDots />
        </Backdrop>
      )}
      {finalErr && (
        <Backdrop ax="center">
          <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />;
        </Backdrop>
      )}
    </>
  );
};

export default IncomeRadios;
